export const ERROR_MESSAGES = {
  REQUIRED_SWID: 'Please input SWID',
  REQUIRED_NICKNAME: 'Please input Nickname',
  REQUIRED_ACCOUNT_ID: 'Please input Account Id',
  REQUIRED_PROFILE_ID: 'Please input Profile Id',
  REQUIRED_APP: 'Please select App',
  REQUIRED_IP: 'Please input IP',
  REQUIRED_CHANNEL: 'Please select a Channel',
  REQUIRED_DISTRIBUTION_PARTNER: 'Please select a Distribution Partner',
  UNABLE_TO_FETCH_IPV4: 'Unable to fetch IPv4',
  IP_TRACING_US_ONLY: 'IP-based tracing is US-only.',
  REQUIRED_DEVICE_IFA: 'Please input Device IFA',
  INVALID_DEVICE_IFA: 'Device IFA must be a valid UUID format',
  REQUIRED_FUBO_USER_ID: 'Please input Fubo User ID',
  INVALID_FUBO_USER_ID: 'Fubo User ID can only contain letters and numbers',
};

export const NEWS_ENT_APPS = [
  'ABC',
  'DISNEYNOW',
  'FREEFORM',
  'FXNOW',
  'NAT_GEO_TV',
  'NATIONAL_GEOGRAPHIC',
  'ABC_NEWS',
  'ABC_NEWS_NEW_YORK',
  'ABC_NEWS_LOS_ANGELES',
  'ABC_NEWS_CHICAGO',
  'ABC_NEWS_PHILADELPHIA',
  'ABC_NEWS_BAY_AREA',
  'ABC_NEWS_HOUSTON',
  'ABC_NEWS_NORTH_CAROLINA',
  'ABC_NEWS_CENTRAL_CALIFORNIA',
  'ABC_NEWS_GOOD_MORNING_AMERICA',
];

export const LAYOUT_STYLES = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const TAIL_STYLES = {
  wrapperCol: { offset: 8, span: 16 },
};
